import { Color } from '@opallabs/gem'
import { getNestedProperty } from '@opallabs/lambda'
import { ApprovalStatus } from '@opallabs/satellite/src/ApprovalItem/types'
import { AssignmentStatus } from '@opallabs/satellite/src/AssignmentHelpers/types'
import {
  ContentCollection,
  MomentCollection,
  PhaseCollection,
  PhaseItem,
  ServiceCollection,
} from '../../../types'
import { decorateServiceName } from '../../jsonApiParser/decorators'
import { NormalizedApproval } from './types'

type PhaseItemToApprovalMapper = (arg: {
  contents: ContentCollection
  moments: MomentCollection
  phaseItems: PhaseItem[]
  phases: PhaseCollection
  services: ServiceCollection
}) => NormalizedApproval[]

export const normalizePhaseItemsToApprovals: PhaseItemToApprovalMapper = ({
  contents,
  moments,
  phaseItems,
  phases,
  services,
}) =>
  phaseItems.map((phaseItem) => {
    const normalizedApproval: NormalizedApproval = {
      approvalName: '',
      approvalStatus:
        phaseItem.status !== undefined
          ? ApprovalStatus[phaseItem.status]
          : ApprovalStatus.incomplete,
      assignmentStatus: AssignmentStatus.Default,
      contextLiveDate: new Date(),
      contextName: '',
      checkpointableDate: new Date(phaseItem.created_at),
      dueDate: undefined,
      entityType: 'phase_item',
      assignmentType: 'approval',
      hardDueDate: false,
      iconColor: Color.light.Text.Gray,
      iconName: decorateServiceName(),
      id: phaseItem.id,
    }
    if (phaseItem.response !== null) {
      normalizedApproval.commentText = phaseItem.response
    }

    let dueDateSet = false

    const phaseId = getNestedProperty<string>(
      phaseItem,
      'relationships',
      'phase',
      'id'
    )
    if (phaseId !== undefined) {
      const phase = phases[phaseId]
      normalizedApproval.approvalName = phase.name

      if (phase.due_date !== null) {
        normalizedApproval.dueDate = new Date(phase.due_date)
        normalizedApproval.hardDueDate = true
        dueDateSet = true
      }
    }
    const contentId = getNestedProperty<string>(
      phaseItem,
      'relationships',
      'approvable',
      'id'
    )
    if (contentId !== undefined) {
      const content = contents[contentId]
      normalizedApproval.contextName = content.name
      normalizedApproval.contentId = contentId

      const momentId = getNestedProperty<string>(
        content,
        'relationships',
        'moment',
        'id'
      )
      if (momentId !== undefined) {
        const moment = moments[momentId]

        // Only set dates if moment.scheduled_at has a valid value
        if (moment.scheduled_at) {
          normalizedApproval.contextLiveDate = new Date(moment.scheduled_at)
          if (!dueDateSet) {
            normalizedApproval.dueDate = new Date(moment.scheduled_at)
          }
        }

        normalizedApproval.momentId = momentId
      }

      const serviceId = getNestedProperty<string>(
        content,
        'relationships',
        'service',
        'id'
      )
      if (serviceId !== undefined) {
        const service = services[serviceId]
        normalizedApproval.iconColor = service.color
        normalizedApproval.iconName = decorateServiceName(
          service.system_name,
          'star',
          true,
          true
        )
      }
    }

    if (normalizedApproval.approvalStatus === ApprovalStatus.complete) {
      normalizedApproval.completedAt = new Date(phaseItem.updated_at)
    }

    return normalizedApproval
  })
